import React from 'react';
import Accordion from 'components/Accordion';
import AccordionTab from 'components/Accordion/AccordionTab';
import { OverviewLayout } from 'components/DetailLayout';
import GlobalStateMessage from 'components/GlobalStateMessage';
import LayoutTile from 'components/LayoutTile';
import OverviewLayoutSection from 'components/OverviewLayout/OverviewLayoutSection';
import useConfig from 'hooks/config.hooks';
import { translate } from 'i18n';
import { useSchema } from 'state/Schema';
import { AccessKeyOverview } from '../AccessKeys';
import DataDomain from './DataDomain';
import { useUserDomains } from './hooks';
import PersonalData from './PersonalData';
import { useAuthentication } from '../../state/Authentication';

const DataOverview: React.FC<{}> = () => {
  const { schema } = useSchema();
  const { PRIVACY_URL } = useConfig();
  const {
    state: { eID },
  } = useAuthentication();

  const userDomains = useUserDomains(schema);

  return (
    <OverviewLayout title="data.overview.title">
      <OverviewLayoutSection
        title={translate('accessKeys.overview.title')}
        description={translate('accessKeys.overview.description')}
      >
        <AccessKeyOverview />
      </OverviewLayoutSection>

      <OverviewLayoutSection
        title={translate('personal_data.overview.title')}
        description={translate('personal_data.overview.description')}
      >
        <GlobalStateMessage location="dataOverview" />

        <Accordion>
          <AccordionTab title={translate('personal_data.tab.title')} id="persoonsgegevens">
            <PersonalData />
          </AccordionTab>

          {userDomains.map(
            (domain) =>
              domain.visibleAttributes.length > 0 && (
                <AccordionTab
                  title={domain.schema.name}
                  id={domain.schema.key}
                  key={domain.schema.key}
                >
                  <DataDomain schema={domain.schema} />
                </AccordionTab>
              ),
          )}
        </Accordion>
      </OverviewLayoutSection>

      <OverviewLayoutSection
        title={translate('personal_data.overview.privacy.title')}
        description={translate('personal_data.overview.privacy.description')}
      >
        <LayoutTile
          to={PRIVACY_URL}
          label={translate('personal_data.overview.privacy.privacy_policy.title')}
          description={translate('personal_data.overview.privacy.privacy_policy.description')}
          toLabel={translate('personal_data.overview.privacy.privacy_policy.action')}
        />

        {!eID?.rrnr ? (
          <LayoutTile
            to="/gegevens/privacy/zwak-profiel/verwijderen"
            label={translate('personal_data.overview.privacy.delete_profile_weak.title')}
            description={
              <span className="u-margin-right">
                {translate('personal_data.overview.privacy.delete_profile_weak.description')}
              </span>
            }
            toLabel={translate('personal_data.overview.privacy.delete_profile_weak.action')}
          />
        ) : (
          <LayoutTile
            to="/gegevens/privacy/sterk-profiel/verwijderen"
            label={translate('personal_data.overview.privacy.delete_profile_strong.title')}
            description={
              <span className="u-margin-right">
                {translate('personal_data.overview.privacy.delete_profile_strong.description')}
              </span>
            }
            toLabel={translate('personal_data.overview.privacy.delete_profile_strong.action')}
          />
        )}
      </OverviewLayoutSection>
    </OverviewLayout>
  );
};

export default DataOverview;
